// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { TERMS_OF_USE_ARTICLE_CLASS_NAME } from "../../../../core/constants/className";

export function TermsOfUseArticle () {
  return (
    <article className={TERMS_OF_USE_ARTICLE_CLASS_NAME}>
      <h1>Käyttöehdot </h1>
    </article>
  );
}
